import { Pipe, PipeTransform } from '@angular/core';
import { VideoYoutube } from '@components/video-youtube/models';
import { Image } from '@shared/components/image/models';
import { Video } from '@shared/components/video/models';

@Pipe({
  name: 'isVideoYoutube',
  standalone: true,
})
export class IsVideoYoutubePipe implements PipeTransform {
  transform(media: Image | Video | VideoYoutube): media is VideoYoutube {
    return 'legend' in media;
  }
}
